const CHECKER_PANEL_STORAGE_KEY = 'checkerPanelState';

export interface CheckerPanelState {
  open: boolean;
  x: number;
  y: number;
  width: number;
  height: number;
  checkerSectionHeight: number;
  productsSectionHeight: number;
}

const defaults: CheckerPanelState = {
  open: false,
  x: Math.max(0, (typeof window !== 'undefined' ? window.innerWidth : 1200) - 850) / 2,
  y: 60,
  width: 850,
  height: 650,
  checkerSectionHeight: 280,
  productsSectionHeight: 300,
};

export function loadCheckerPanelState(): CheckerPanelState {
  try {
    const raw = localStorage.getItem(CHECKER_PANEL_STORAGE_KEY);
    if (!raw) return { ...defaults };
    const parsed = JSON.parse(raw);
    return {
      open: Boolean(parsed.open),
      x: (parsed.x != null && parsed.x !== '') ? Number(parsed.x) : defaults.x,
      y: (parsed.y != null && parsed.y !== '') ? Number(parsed.y) : defaults.y,
      width: Number(parsed.width) || defaults.width,
      height: Number(parsed.height) || defaults.height,
      checkerSectionHeight: Number(parsed.checkerSectionHeight) || defaults.checkerSectionHeight,
      productsSectionHeight: Number(parsed.productsSectionHeight) || defaults.productsSectionHeight,
    };
  } catch {
    return { ...defaults };
  }
}

export function saveCheckerPanelState(state: Partial<CheckerPanelState>): void {
  try {
    const current = loadCheckerPanelState();
    const merged = { ...current, ...state };
    localStorage.setItem(CHECKER_PANEL_STORAGE_KEY, JSON.stringify(merged));
  } catch {
    // ignore
  }
}
